module.exports = __webpack_public_path__ + "static/media/dual-diagnosis.bbc8a279.svg";